var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneHeartBeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5C5 3.34315 6.34315 2 8 2H16C17.6569 2 19 3.34315 19 5V10.25H16C15.7492 10.25 15.5151 10.3753 15.376 10.584L13.9449 12.7306L10.5857 8.53148C10.4408 8.35036 10.2202 8.24647 9.98829 8.25009C9.75636 8.25371 9.53917 8.36444 9.4 8.55L6.625 12.25H5V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4014 11.75H19V19C19 20.6569 17.6569 22 16 22H8C6.34315 22 5 20.6569 5 19V13.75H7C7.23607 13.75 7.45836 13.6389 7.6 13.45L10.0191 10.2245L13.4143 14.4685C13.5638 14.6554 13.7935 14.7597 14.0325 14.7493C14.2716 14.7389 14.4913 14.6151 14.624 14.416L16.4014 11.75ZM9 18.25C8.58579 18.25 8.25 18.5858 8.25 19C8.25 19.4142 8.58579 19.75 9 19.75H15C15.4142 19.75 15.75 19.4142 15.75 19C15.75 18.5858 15.4142 18.25 15 18.25H9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneHeartBeat);
export default __webpack_public_path__ + "static/media/smartphone-heart-beat.77b7e5b675baab66a4da87fa8c172d9d.svg";
export { ForwardRef as ReactComponent };